import { render, staticRenderFns } from "./dayCleanConfig.vue?vue&type=template&id=79c47dec&scoped=true"
import script from "./dayCleanConfig.vue?vue&type=script&lang=js"
export * from "./dayCleanConfig.vue?vue&type=script&lang=js"
import style0 from "./dayCleanConfig.vue?vue&type=style&index=0&id=79c47dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c47dec",
  null
  
)

export default component.exports